"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-91ede1f6"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "すべて選択", -1 /* HOISTED */));
const _hoisted_2 = { class: "oplus-gray-text" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "コピー", -1 /* HOISTED */));
const _hoisted_4 = { class: "oplus-gray-text" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "切り取り", -1 /* HOISTED */));
const _hoisted_6 = { class: "oplus-gray-text" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "貼り付け", -1 /* HOISTED */));
const _hoisted_8 = { class: "oplus-gray-text" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "戻す", -1 /* HOISTED */));
const _hoisted_10 = { class: "oplus-gray-text" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "削除", -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-gray-text oplus-delete-text" }, "Delete", -1 /* HOISTED */));
const _hoisted_13 = [
    _hoisted_11,
    _hoisted_12
];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "終了", -1 /* HOISTED */));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-gray-text" }, "Esc", -1 /* HOISTED */));
const _hoisted_16 = [
    _hoisted_14,
    _hoisted_15
];
const vue_3 = require("vue");
const tableEditMode_1 = require("../tableEditMode");
const summary_lib_1 = require("../../js/summary_lib");
const slot_undo_1 = require("../../js/slot_undo");
const osType_1 = require("../enums/osType");
const viewTypes_1 = __importDefault(require("../../table/v1/viewTypes"));
const dwsTableEditMode_1 = require("../dwsTableEditMode");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CellEditMenu',
    props: {
        osType: {
            type: String,
            required: true,
        },
        viewType: {
            type: String,
            required: true,
        },
        isUsingRequestSlots: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["edit-menu-ref"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const deleteSelection = (0, vue_3.ref)();
        const editMenuRef = (0, vue_3.ref)(null);
        const emit = __emit;
        function handleSelectAllClick() {
            if (props.viewType === viewTypes_1.default.DAY) {
                (0, dwsTableEditMode_1.handleDwsSelectAll)();
            }
            else {
                (0, tableEditMode_1.handleSelectAll)();
            }
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handleCopyClick() {
            (0, tableEditMode_1.handleCellCopyOrCut)(true);
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handleCutClick() {
            (0, tableEditMode_1.handleCellCopyOrCut)(false);
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handlePasteClick() {
            (0, tableEditMode_1.handleCellPaste)();
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handleUndoClick() {
            if (props.isUsingRequestSlots) {
                return;
            }
            (0, summary_lib_1.undoHandler)();
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handleDeleteClick() {
            (0, tableEditMode_1.handleCellDelete)(deleteSelection.value);
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        async function handleDeleteHover() {
            deleteSelection.value = await (0, tableEditMode_1.selectCellsForDeletion)();
        }
        function handleDeleteLeave() {
            (0, tableEditMode_1.resetDeleteSelection)(deleteSelection.value);
            deleteSelection.value = undefined;
        }
        function handleExitClick() {
            (0, tableEditMode_1.destroyCellEdit)();
        }
        const shortcutText = (0, vue_3.computed)(() => {
            let iconText = "";
            switch (props.osType) {
                case osType_1.OSType.MAC:
                    iconText = "⌘";
                    break;
                case osType_1.OSType.WINDOWS:
                    iconText = "Ctrl";
                    break;
            }
            // will implement android/ios in another task
            return iconText;
        });
        const undoButtonClass = (0, vue_3.computed)(() => {
            return (0, slot_undo_1.isUndoButtonDisabled)() ? "disabled-btn" : "";
        });
        const showUndoButton = (0, vue_3.computed)(() => {
            return !props.isUsingRequestSlots && props.viewType !== viewTypes_1.default.DAY;
        });
        (0, vue_3.onMounted)(() => {
            emit('edit-menu-ref', editMenuRef);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                ref_key: "editMenuRef",
                ref: editMenuRef,
                class: "cell-edit-menu-wrapper"
            }, [
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleSelectAllClick
                }, [
                    _hoisted_1,
                    (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)(shortcutText.value) + " A", 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleCopyClick
                }, [
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(shortcutText.value) + " C", 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleCutClick
                }, [
                    _hoisted_5,
                    (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(shortcutText.value) + " X", 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handlePasteClick
                }, [
                    _hoisted_7,
                    (0, vue_2.createElementVNode)("span", _hoisted_8, (0, vue_2.toDisplayString)(shortcutText.value) + " V", 1 /* TEXT */)
                ]),
                (showUndoButton.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        class: (0, vue_2.normalizeClass)(["cell-edit-menu-item", undoButtonClass.value]),
                        onClick: handleUndoClick
                    }, [
                        _hoisted_9,
                        (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(shortcutText.value) + " Z", 1 /* TEXT */)
                    ], 2 /* CLASS */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.viewType !== (0, vue_2.unref)(viewTypes_1.default).DAY)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 1,
                        class: "cell-edit-menu-item oplus-delete-text",
                        onClick: handleDeleteClick,
                        onMouseenter: handleDeleteHover,
                        onMouseleave: handleDeleteLeave
                    }, _hoisted_13, 32 /* NEED_HYDRATION */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleExitClick
                }, _hoisted_16)
            ], 512 /* NEED_PATCH */));
        };
    }
});
